import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

// Setup Axios
import axios from 'axios'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
export const api = axios

// Setup Storage
import Storage from '@entities/Storage'
export const storage = new Storage()

// Import React screens
import Welcome from '@screens/Welcome'
import Register from '@screens/Register'
import Login from '@screens/Login'
import Dashboard from '@screens/Dashboard'
import Account from '@screens/Account'
import Payment from '@screens/Payment'
import Source from '@screens/Source'

import { Context } from '@entities/Context';
import Title from '@components/Title'
import Header from '@components/Header' // <-- header component

export const routes = [
	{ path: '/', name: 'index', title: 'Online Giving', width: 'wide', element: <Welcome /> },
	{ path: '/welcome', name: 'welcome', title: 'Online Giving', width: 'wide', element: <Welcome /> },
	{ path: '/register', name: 'register', title: 'Create an Account', width: 'wide', element: <Register /> },
	{ path: '/login', name: 'login', title: 'Member Login', width: 'narrow', element: <Login /> },
	{ path: '/dashboard', name: 'dashboard', title: 'Dashboard', width: 'wide', element: <Dashboard /> },
	{ path: '/account', name: 'account', title: 'My Account', width: 'wide', element: <Account /> },
	{ path: '/payment', name: 'payment', title: 'Make a Contribution', width: 'wide', element: <Payment /> },
	{ path: '/source', name: 'source', title: 'Add a Card', width: 'wide', element: <Source /> },
]

const container = document.getElementById('app')
if (container) {
	const root = createRoot(container)

	const dataset = Object.fromEntries(Object.entries(container.dataset).map(([key, value]) => [key, JSON.parse(value)]))

	root.render(
		<StrictMode>
			<Context.Provider value={{...dataset, api, storage}}>
				<BrowserRouter>
					<Header /> {/* Renders via a portal but needs the Context.Provider and Browser Router */}
					<Title routes={routes}>
						<Routes>
							{routes.map((route) => (
								<Route key={route.path} path={route.path} element={route.element} />
							))}
						</Routes>
					</Title>
				</BrowserRouter>
			</Context.Provider>
		</StrictMode>
	)
}
